import { render, staticRenderFns } from "./BusinessStatus.vue?vue&type=template&id=1ec501c6&scoped=true"
import script from "./BusinessStatus.vue?vue&type=script&lang=js"
export * from "./BusinessStatus.vue?vue&type=script&lang=js"
import style0 from "./BusinessStatus.vue?vue&type=style&index=0&id=1ec501c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec501c6",
  null
  
)

export default component.exports